import { createContext, useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBeautyProduct } from '../../../beauty-shared/context/BeautyProductContext';
import { SALON_HUB_PATH } from '../../salon/config/salonApp';

const MakeupHairNavContext = createContext(null);

export function MakeupHairNavProvider({ children }) {
  const navigate = useNavigate();
  const { hubPath } = useBeautyProduct();

  const goHub = useCallback(
    () => navigate(hubPath || SALON_HUB_PATH),
    [navigate, hubPath],
  );

  const value = useMemo(
    () => ({
      onSwitchApp: goHub,
      onHome: goHub,
    }),
    [goHub],
  );

  return (
    <MakeupHairNavContext.Provider value={value}>
      {children}
    </MakeupHairNavContext.Provider>
  );
}

export function useMakeupHairNav() {
  return useContext(MakeupHairNavContext);
}
